<div class="tabs">
  <div class="info unselected">
    <p>{{ description }}</p>
  </div>
  <div
    class="tab"
    *ngIf="tabs[0]; else emptyTab"
    [ngClass]="isSelected(tabs[0].value)"
    (click)="updateSelected(tabs[0].value, tabs[0].link)"
    (keypress)="updateSelected(tabs[0].value, tabs[0].link)"
    tabindex="0"
  >
    <h2 class="adjust-margin" [ngClass]="isHeaderSelected(tabs[0].value)">
      {{ tabs[0].title }}
    </h2>
    <ol type="a" class="list adjust-margin">
      <li
        class="subtitle"
        *ngFor="let subtitle of tabs[0].subtitles"
        (click)="subtitleLink(subtitle, tabs[0])"
        (keypress)="subtitleLink(subtitle, tabs[0])"
        tabindex="0"
      >
        <span class="link" [ngClass]="isSubtitleSelected(subtitle.value)">{{
          subtitle.name
        }}</span>
      </li>
    </ol>
  </div>
  <div
    class="tab"
    *ngIf="tabs[1]; else emptyTab"
    [ngClass]="isSelected(tabs[1].value)"
    (click)="updateSelected(tabs[1].value, tabs[1].link)"
    (keypress)="updateSelected(tabs[1].value, tabs[1].link)"
    tabindex="0"
  >
    <h2 class="adjust-margin" [ngClass]="isHeaderSelected(tabs[1].value)">
      {{ tabs[1].title }}
    </h2>
    <ol type="a" class="list adjust-margin">
      <li
        class="subtitle"
        *ngFor="let subtitle of tabs[1].subtitles"
        (click)="subtitleLink(subtitle, tabs[1])"
        (keypress)="subtitleLink(subtitle, tabs[1])"
        tabindex="0"
      >
        <span class="link" [ngClass]="isSubtitleSelected(subtitle.value)">{{
          subtitle.name
        }}</span>
      </li>
    </ol>
  </div>
  <div
    class="tab"
    *ngIf="tabs[2]; else emptyTab"
    [ngClass]="isSelected(tabs[2].value)"
    (click)="updateSelected(tabs[2].value, tabs[2].link)"
    (keypress)="updateSelected(tabs[2].value, tabs[2].link)"
    tabindex="0"
  >
    <h2 class="adjust-margin" [ngClass]="isHeaderSelected(tabs[2].value)">
      {{ tabs[2].title }}
    </h2>
    <ol type="a" class="list adjust-margin">
      <li
        class="subtitle"
        *ngFor="let subtitle of tabs[2].subtitles"
        (click)="subtitleLink(subtitle, tabs[2])"
        (keypress)="subtitleLink(subtitle, tabs[2])"
        tabindex="0"
      >
        <span class="link" [ngClass]="isSubtitleSelected(subtitle.value)">{{
          subtitle.name
        }}</span>
      </li>
    </ol>
  </div>
</div>

<ng-template #emptyTab>
  <div class="tab unselected"></div>
</ng-template>
